var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-industry", style: _vm.cssVars }, [
    _c("div", { staticClass: "mobile-section-title" }, [
      _c("span", [_vm._v("您是哪个行业？")]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "mobile-section-title__more",
          on: { click: _vm.toggleMore },
        },
        [_vm._v("\n      " + _vm._s(_vm.expanded ? "收起" : "更多") + "\n    ")]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mobile-industry__list" },
      _vm._l(_vm.displayData, function (item, index) {
        return _c(
          "div",
          {
            key: item.id || index,
            staticClass: "mobile-industry__item",
            on: {
              click: function ($event) {
                return _vm.handleClick(item)
              },
            },
          },
          [
            _c("div", { staticClass: "mobile-industry__icon-wrap" }, [
              _c("img", {
                staticClass: "mobile-industry__icon",
                attrs: { src: _vm.getIcon(index), alt: "" },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-industry__name" }, [
              _vm._v(_vm._s(item.industryDetailName || item.name)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mobile-industry__count" }, [
              _vm._v(_vm._s(item.count || 0)),
            ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }